<div class="container px-4">
  <div class="transactions-page">
    <!-- Header Section -->
    <header class="page-header">
      <h1>Transactions</h1>
      <p>View and track your transaction history</p>
    </header>

    <!-- Empty State -->
    <div class="empty-state">
      <div class="icon">
        <img src="/dashboard/transactions.png" alt="Transactions Icon" />
      </div>
      <h2>You Don’t Have Any Transactions Yet</h2>
      <p>Once a transaction is created, it will be displayed here.</p>
    </div>
  </div>
</div>
